/* global  */ // tUrl等のグローバル変数を宣言する
import scrollLock from './functions/_scrollLock.js' // スクロールロック

import './module/_hashScroll' // アンカーリンクスクロール
import './module/_spMenuToggle' // SPメニュー開閉
import './module/_toast' // トースト通知
import isDevice from './functions/_isDevice.js' // UserAgentをpc,sp,tabの形で返す

import './_inputTrace'
import './_api'
import './_ajax'
import './_rating'
import './_lang'
import './_top'
import './_search'
import './_expand'
import './_ppv'
import './_favorite'
import './_video'
import './_review'
import './_range-slider'
import './_leave'
import './_favorite-tag'
import './_favorite-list'
import './_dialog'
import './_card-list'
import './_bbs'
import './_cart'
import './_form'
import './_destroyParent'
import './_trace'
import './_getAjax'
import './_cartCount'

// import 'core-js/features/number/is-nan' // SwiperのIE対応
// import 'custom-event-polyfill' // SwiperのIE対応
// import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
// Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

/*
 ##     ## ##     ##          ######  ##    ## ##    ##  ######
 ##     ## ##     ##         ##         ####   ####  ## ##
 ######### ##     ## #######  ######     ##    ## ## ## ##
 ##     ##  ##   ##                ##    ##    ##  #### ##
 ##     ##    ###             ######     ##    ##    ##  ######
ホバー中、その要素とその連動要素全てに.hoverを付与

<a href="" class="js-hoverSync js-hoverSync--hoge" data-hover-sync="hoge"></a>
<a href="" class="js-hoverSync js-hoverSync--hoge" data-hover-sync="hoge"></a>
*/
const hoverSyncClass = 'js-hoverSync'
if (document.getElementsByClassName(hoverSyncClass)[0]) {
  hoverSync()
}
function hoverSync() {
  const hoverActiveClass = 'hover'
  const hoverItems = document.getElementsByClassName(hoverSyncClass)
  for (let index = 0; index < hoverItems.length; index++) {
    const hoverItem = hoverItems[index]
    if (!hoverItem.dataset.hoverSync) {
      continue
    }
    const hoverTargets = document.getElementsByClassName(hoverSyncClass + '--' + hoverItem.dataset.hoverSync)
    hoverItem.addEventListener(
      'mouseover',
      function () {
        for (let index = 0; index < hoverTargets.length; index++) {
          hoverTargets[index].classList.add(hoverActiveClass)
        }
      },
      false
    )
    hoverItem.addEventListener(
      'mouseout',
      function () {
        for (let index = 0; index < hoverTargets.length; index++) {
          hoverTargets[index].classList.remove(hoverActiveClass)
        }
      },
      false
    )
  }
}

//   ####  #####  ##                    ##  ##   ##  ###    ###  #####
//  ##     ##     ##                    ##  ##   ##  ## #  # ##  ##  ##
//   ###   #####  ##      ########      ##  ##   ##  ##  ##  ##  #####
//     ##  ##     ##                ##  ##  ##   ##  ##      ##  ##
//  ####   #####  ######             ####    #####   ##      ##  ##
// セレクトボックスで選んだURLにジャンプする
const selectJump = document.getElementsByClassName('js-selectJump')
if (selectJump[0]) {
  window.addEventListener('change', function (e) {
    if (!e.target.classList.contains('js-selectJump')) {
      return
    }
    window.location.href = e.target.value
  })
}

//  ###    ###   #####   ####      ###    ##
//  ## #  # ##  ##   ##  ##  ##   ## ##   ##
//  ##  ##  ##  ##   ##  ##  ##  ##   ##  ##
//  ##      ##  ##   ##  ##  ##  #######  ##
//  ##      ##   #####   ####    ##   ##  ######

const modalOverlay = document.getElementById('modalOverlay') // モーダル用オーバーレイ
const modals = document.getElementsByClassName('js-modal') // モーダル本体
if (modals[0]) {
  window.addEventListener('click', (e) => {
    if (!e.target.closest('.js-modal-open')) {
      return
    }
    e.preventDefault()
    window.modalClose()
    const target = e.target.closest('.js-modal-open').dataset.modal
    const btn = e.target.closest('.js-modal-open')

    btn.classList.add('curr')

    const openModals = document.querySelectorAll('.js-modal--' + target)
    for (const openModal of openModals) {
      openModal.classList.add('active')
    }

    modalOverlay.classList.add('active')
    scrollLock('body', '#modalOverlay')
  })
  // モーダル撤去
  window.addEventListener('click', (e) => {
    if (!e.target.closest('.js-modal-close')) {
      return
    }
    e.preventDefault()
    window.modalClose()
    modalOverlay.classList.remove('active')

    const currClass = document.getElementsByClassName('curr')

    if (currClass.length > 0) {
      currClass[0].classList.remove('curr')
    }
    scrollLock('body', '#modalOverlay')
  })
}

window.modalClose = function () {
  // モーダルを消す
  for (let index = 0; index < modals.length; index++) {
    const modal = modals[index]
    modal.classList.remove('active')
  }
}

/*
  ######          ########  #######   ######    ######   ##       ########
 ##                  ##    ##     ## ##        ##        ##       ##
 ##       #######    ##    ##     ## ##   #### ##   #### ##       ######
 ##                  ##    ##     ## ##    ##  ##    ##  ##       ##
  ######             ##     #######   ######    ######   ######## ########

// クリックされたとき、属するグループのクラスを反転させる
<button type="button" class="js-clickToggle" data-toggle-group="hogeGroup"></button>
<div class="js-clickToggle--hogeGroup"></div>

*/
window.addEventListener('click', function (e) {
  if (!e.target.classList.contains('js-clickToggle')) {
    return
  }

  const group = e.target.dataset.toggleGroup
  toggleGroup(group, 'active')
})

function toggleGroup(group, className = 'active') {
  const hide = document.getElementsByClassName('js-clickToggle--' + group)
  for (let index = 0; index < hide.length; index++) {
    hide[index].classList.toggle(className)
  }
}

//   ####            ######   #####     ###     ####  ######
//  ##                 ##    ##   ##   ## ##   ##       ##
//  ##     ########    ##    ##   ##  ##   ##   ###     ##
//  ##                 ##    ##   ##  #######     ##    ##
//   ####              ##     #####   ##   ##  ####     ##
/*
<button type="button" class="js-clickToast" data-toast-on="お気に入りに登録しました" data-toast-off="お気に入りから削除しました">
</button>
*/
window.addEventListener('click', function (e) {
  if (!e.target.classList.contains('js-clickToast')) {
    return
  }

  const toastClass = e.target.dataset.toastClass

  // .activeの有無でONOFFを判断　.js-clickToggleの処理が先に行われる前提
  if (e.target.classList.contains('active')) {
    window.popToast(e.target.dataset.toastOn, toastClass)
  } else {
    window.popToast(e.target.dataset.toastOff, toastClass)
  }

  window.favCheck() // お気に入りチェック
})

//   ####   ####  #####     #####   ##      ##
//  ##     ##     ##  ##   ##   ##  ##      ##
//   ###   ##     #####    ##   ##  ##      ##
//     ##  ##     ##  ##   ##   ##  ##      ##
//  ####    ####  ##   ##   #####   ######  ######

/**
 * @function scrollValToggle
 * @description スクロール量を基準にクラスを着脱する
 * @param {String} targetSelector ターゲットとする一意なセレクタ
 * @param {Number} scrollValStart 有効範囲となるスクロール量　上からの距離
 * @param {Number|Boolean} [scrollValEnd=false] 有効範囲外となるスクロール量　下からの距離
 * @param {String} toggleClass 切り替えるクラス名
 * @return {Void}
 */
scrollValToggle('#pagetop', 500, false, 'active')
function scrollValToggle(targetSelector, scrollValStart = 500, scrollValEnd = false, toggleClass = 'active') {
  if (!document.querySelector(targetSelector)) {
    return
  }
  let isExecute = false // 実行中フラグ
  let scrollY = 0 // 縦方向のスクロール量
  const target = document.querySelector(targetSelector) // ターゲット要素
  let scToggleActive = false // ターゲット要素のONOFF状態
  document.addEventListener('scroll', function (ev) {
    scrollValToggleApply()
  })
  scrollValToggleApply() // 初回起動
  function scrollValToggleApply() {
    if (isExecute) {
      // 実行中ならスキップ
      return
    }
    isExecute = true
    // レンダリング準備が整ったら開始
    requestAnimationFrame(function () {
      scrollY = window.scrollY // スクロール量
      if (scrollY >= scrollValStart && !scToggleActive) {
        //トップから指定px以上スクロールしたらON
        target.classList.add(toggleClass)
        scToggleActive = true
      } else if (scrollY < scrollValStart && scToggleActive) {
        //スクロールが足りない時はOFF
        target.classList.remove(toggleClass)
        scToggleActive = false
      }
      if (scrollValEnd && scToggleActive) {
        // 終了ラインが設定されている場合は終了判定
        if (scrollY + window.innerHeight > document.documentElement.offsetHeight - scrollValEnd) {
          //スクロール終了範囲を過ぎていたらOFF
          target.classList.remove(toggleClass)
          scToggleActive = false
        }
      }
      isExecute = false
    })
  }
}

//   ####  ##  ####    #####
//  ##     ##  ##  ##  ##
//   ###   ##  ##  ##  #####
//     ##  ##  ##  ##  ##
//  ####   ##  ####    #####
// PCでなければサイドバーの衣装欄を閉じる
if (isDevice !== 'pc') {
  const sideCheck = document.getElementsByClassName('js-sideWear')
  for (const iterator of sideCheck) {
    iterator.checked = false
  }
}

/*
  ######          ######## ##     ##  ######  ##
 ##               ##         ## ##   ##       ##
 ##       ####### ######      ###    ##       ##
 ##               ##         ## ##   ##       ##
  ######          ######## ##     ##  ######  ########

// クリックされたとき、属するグループのクラスを非アクティブにし、指定ターゲットだけアクティブにする
<button type="button" class="js-clickExclActive" data-excl-group="hogeGroup" data-excl-target="fugaTarget"></button>
<div class="js-clickExclActive-group--hogeGroup js-clickExclActive-target--fugaTarget"></div>

*/
if (document.getElementsByClassName('js-clickExclActive')[0]) {
  window.addEventListener('click', function (e) {
    if (!e.target.classList.contains('js-clickExclActive')) {
      return
    }
    const group = e.target.dataset.exclGroup
    const target = e.target.dataset.exclTarget
    exclActive(group, target, 'active')
  })
}
function exclActive(group, target, className = 'active') {
  const hide = document.getElementsByClassName('js-clickExclActive-group--' + group)
  for (let index = 0; index < hide.length; index++) {
    hide[index].classList.remove(className)
  }
  const view = document.getElementsByClassName('js-clickExclActive-target--' + target)
  for (let index = 0; index < view.length; index++) {
    view[index].classList.add(className)
  }
}

//  ####    #####   ####  ######  #####     #####   ##    ##
//  ##  ##  ##     ##       ##    ##  ##   ##   ##   ##  ##
//  ##  ##  #####   ###     ##    #####    ##   ##    ####
//  ##  ##  ##        ##    ##    ##  ##   ##   ##     ##
//  ####    #####  ####     ##    ##   ##   #####      ##
/*
data属性に対応するクラスのDOMを削除する
<button type="button" class="js-destroy" data-destroy="hoge">
    削除
</button>
<div class="js-destroy--hoge">これが消える</div>
*/

window.addEventListener('click', function (e) {
  // 指定のクラスを持つ
  if (!e.target.classList.contains('js-destroy')) {
    return
  }
  const target = e.target.dataset.destroy
  const destroyList = document.getElementsByClassName('js-destroy--' + target)

  for (const iterator of destroyList) {
    iterator.parentNode.removeChild(iterator)
  }
})
